import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const PointsUsage = () => {
  const [pointsData, setPointsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPointsData = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/point-costs`);
        setPointsData(response.data);
      } catch (error) {
        console.error('Error fetching point costs:', error);
        // Fallback to static data if API fails
        setPointsData([
          { displayName: '掲示板閲覧', pointCost: 5 },
          { displayName: 'プロフィール閲覧', pointCost: 5 },
          { displayName: '通常メール送信', pointCost: 0 },
          { displayName: '掲示板書き込み', pointCost: 0 },
          { displayName: 'アドレスメール送信', pointCost: 1000 },
          { displayName: 'アドレスメール閲覧', pointCost: 500 },
          { displayName: '未読メール閲覧', pointCost: 0 },
          { displayName: '既読メール閲覧', pointCost: 0 },
          { displayName: 'プロフィール写真閲覧', pointCost: 0 },
          { displayName: 'メール添付写真閲覧', pointCost: 0 },
          { displayName: '写真登録', pointCost: 5 },
          { displayName: 'ムービー再生', pointCost: 0 }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchPointsData();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <p>読み込み中...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '30px', color: '#333', textAlign: 'center' }}>
        ポイント使用確認
      </h2>
      
      {/* <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
        <div style={{
          backgroundColor: '#34495e',
          color: 'white',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h3 style={{ margin: 0, fontSize: '18px' }}>
            各アクションのポイント消費について
          </h3>
          <p style={{ margin: '10px 0 0 0', opacity: 0.9, fontSize: '14px' }}>
            以下の表に各機能の利用時に消費されるポイント数を記載しています
          </p>
        </div>
        
        <div style={{ padding: '20px' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '10px'
          }}>
            <thead>
              <tr style={{
                backgroundColor: '#f8f9fa',
                borderBottom: '2px solid #dee2e6'
              }}>
                <th style={{
                  padding: '15px',
                  textAlign: 'left',
                  borderBottom: '2px solid #dee2e6',
                  color: '#495057',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}>
                  アクション
                </th>
                <th style={{
                  padding: '15px',
                  textAlign: 'center',
                  borderBottom: '2px solid #dee2e6',
                  color: '#495057',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  width: '150px'
                }}>
                  消費ポイント
                </th>
              </tr>
            </thead>
            <tbody>
              {pointsData.map((item, index) => (
                <tr key={index} style={{
                  borderBottom: '1px solid #dee2e6',
                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                }}>
                  <td style={{
                    padding: '15px',
                    fontSize: '15px',
                    color: '#333',
                    fontWeight: '500'
                  }}>
                    {item.displayName}
                  </td>
                  <td style={{
                    padding: '15px',
                    textAlign: 'center',
                    fontSize: '16px',
                    fontWeight: 'bold'
                  }}>
                    <span style={{
                      backgroundColor: item.pointCost === 0 ? '#28a745' : item.pointCost <= 5 ? '#ffc107' : '#dc3545',
                      color: item.pointCost === 0 ? 'white' : item.pointCost <= 5 ? '#212529' : 'white',
                      padding: '6px 12px',
                      borderRadius: '20px',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      display: 'inline-block',
                      minWidth: '60px'
                    }}>
                      {item.pointCost}pt
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '20px',
          borderTop: '1px solid #dee2e6'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: '#28a745'
              }}></div>
              <span style={{ fontSize: '14px', color: '#666' }}>無料</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: '#ffc107'
              }}></div>
              <span style={{ fontSize: '14px', color: '#666' }}>低コスト (1-5pt)</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: '#dc3545'
              }}></div>
              <span style={{ fontSize: '14px', color: '#666' }}>高コスト (500pt以上)</span>
            </div>
          </div>
        </div>
      </div> */}
      
      <div style={{
        marginTop: '30px',
        padding: '20px',
        backgroundColor: '#e8f4fd',
        borderRadius: '8px',
        border: '1px solid #bee5eb'
      }}>
        <h4 style={{ margin: '0 0 15px 0', color: '#0c5460' }}>
          📋 ポイント使用についての注意事項
        </h4>
        <ul style={{ margin: 0, paddingLeft: '20px', color: '#0c5460' }}>
          <li style={{ marginBottom: '8px' }}>
            ポイントは各アクション実行時に自動的に消費されます
          </li>
          <li style={{ marginBottom: '8px' }}>
            ポイントが不足している場合は、該当機能を利用できません
          </li>
          <li style={{ marginBottom: '8px' }}>
            メールを送信するときは送信ポイント量だけ消費されます
          </li>
          <li style={{ marginBottom: '8px' }}>
            掲示板の閲覧やプロフィール閲覧は低コストで利用できます
          </li>
          <li>
            通常のメール送信や掲示板書き込みは無料で利用できます
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PointsUsage; 